import React, { useState } from 'react';
import './ChangePasswordModal.css';
import axios from '../api/axiosInstance';

const ChangePasswordModal = ({ onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirm password do not match.');
      return;
    }

    try {
      await axios.put('/api/users/change-password', {
        currentPassword,
        newPassword,
      });

      setSuccess('Password updated successfully!');
      setTimeout(onClose, 1500);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to change password.');
    }
  };

  const renderPasswordField = (label, value, setValue, show, setShow) => (
    <label>
      {label}
      <div className="password-input-wrapper">
        <input
          type={show ? 'text' : 'password'}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button
          type="button"
          className="toggle-password-btn"
          onClick={() => setShow(!show)}
        >
          {show ? 'Hide' : 'Show'}
        </button>
      </div>
    </label>
  );

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Change Password</h2>
        <form onSubmit={handleSubmit}>
          {renderPasswordField("Current Password:", currentPassword, setCurrentPassword, showCurrent, setShowCurrent)}
          {renderPasswordField("New Password:", newPassword, setNewPassword, showNew, setShowNew)}
          {renderPasswordField("Confirm New Password:", confirmPassword, setConfirmPassword, showConfirm, setShowConfirm)}

          {error && <p className="error-text">{error}</p>}
          {success && <p className="success-text">{success}</p>}

          <div className="modal-actions">
            <button type="submit">Save</button>
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
